import {Module} from "vuex";
import {RootState} from "@/store/types";
import { callStatistic } from "./statistic";
import { callIvrMenus } from "./ivr_menus";
import { callSounds } from "@/store/call/sounds";

export const callModule: Module<any, RootState> = {
  modules: {
    callStatistic,
    callIvrMenus,
    callSounds,
    // callTemplate,
    // callFilter,
  }
}
